<div class="item-grabber">
  <rt-icon name="drag-vertical"></rt-icon>
</div>

<div class="item-content">
  @if (!titleEditorOpen) {
    <div class="item-title-actions">
      <div class="item-title">
        {{ title }}
      </div>
      @if (editable) {
        <div class="item-actions">
          <rt-group>
            @if (renamable) {
              <rt-icon-button
                (click)="onEditItemClick()"
                iconName="edit"
                shape="square"
                variant="plain"
              >
              </rt-icon-button>
            }
            @if (removable) {
              <rt-icon-button
                [loading]="processing"
                (click)="onDeleteItemClick()"
                variant="plain"
                iconName="delete"
                shape="square"
                class="danger-on-hover"
              >
              </rt-icon-button>
            }
          </rt-group>
        </div>
      }
    </div>
  }
  @if (titleEditorOpen) {
    <rt-list-sortable-form
      [value]="title"
      (cancelClick)="onCancelClick()"
      (saveClick)="onEditName($event)"
    >
    </rt-list-sortable-form>
  }
</div>
